window.app = window.app || {};

window.app.contactCategories = {
    el: {
        buttons: document.querySelectorAll('.mt-contact-categories__item .mt-btn'),
        modal: document.querySelector('#contact-form-modal'),
        modalHeader: document.querySelector('#contact-form-modal .mt-hs-cf__header'),
        modalForm: document.querySelector('#contact-form-modal .mt-hs-cf__form')
    },

    init: function () {
        const _this = this;
        if (_this.el.buttons.length === 0 || !_this.el.modal) return;

        _this.el.buttons.forEach(button => {
            button.addEventListener('click', e => {
                const item = button.closest('.mt-contact-categories__item');
                const itemTitle = item ? item.querySelector('.mt-contact-categories__item-title') : null;
                const formData = {
                    header: button.dataset.formHeader,
                    portalId: button.dataset.portalId,
                    formId: button.dataset.formId
                };
                _this.el.modalHeader.innerHTML = '';
                _this.el.modalForm.innerHTML = '';

                (formData.header != '') && (_this.el.modalHeader.innerHTML = formData.header);

                if (formData.portalId && formData.formId) {
                    const hbsptScript = document.createElement('script');
                    hbsptScript.innerHTML = `hbspt.forms.create({ region: "na1", portalId: "${formData.portalId}", formId: "${formData.formId}" });`;
                    _this.el.modalForm.appendChild(hbsptScript);
                    app.modal.open(_this.el.modal);
                }

                // DL Event
                if (itemTitle) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                    event: 'reach_out_cta_click',
                        link_text: itemTitle.innerText
                    });
                }
            });

            // Additional triggers
            if (button.dataset?.formId !== '') {
                const triggers = document.querySelectorAll(`[href="#form-${button.dataset.formId}"]`);
                triggers.forEach(t => {
                    t.addEventListener('click', e => {
                        e.preventDefault();
                        e.stopPropagation();
                        button.click();
                    });
                });
            }
        });
    }
}
window.app.contactCategories.init();